import { getUserAccessToken } from '@/utils/account/getUserAccessToken';
import {
  fetchCurrentProfile as fetchCurrentProfileServer,
  deleteCurrentProfile as deleteCurrentProfileServer,
  updateProfile as updateProfileServer,
} from '@/actions/persons';

export const fetchCurrentProfile = async (accessToken: string | undefined = undefined) => {
  const userAccessToken = accessToken ?? (await getUserAccessToken());
  return fetchCurrentProfileServer(userAccessToken);
};

export const deleteCurrentProfile = async () => {
  const userAccessToken = await getUserAccessToken();
  return deleteCurrentProfileServer(userAccessToken);
};

export const updateProfile = async (id: string, data: any) => {
  const userAccessToken = await getUserAccessToken();
  return updateProfileServer(userAccessToken, id, data);
};
